// extracted by mini-css-extract-plugin
module.exports = {"navbar":"MainNav_navbar__2OB7A","logo":"MainNav_logo__9Ywgo"};